var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.28,
    y: 73.82,
    width: 271.68,
    height: 152.98,
    rx: 10.83,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.13,227.8h-250A11.84,11.84,0,0,1,162.28,216V84.65a11.84,11.84,0,0,1,11.83-11.83h250A11.85,11.85,0,0,1,436,84.65V216A11.85,11.85,0,0,1,424.13,227.8Zm-250-153a9.84,9.84,0,0,0-9.83,9.83V216a9.84,9.84,0,0,0,9.83,9.83h250A9.84,9.84,0,0,0,434,216V84.65a9.84,9.84,0,0,0-9.83-9.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.61,167.68h43V190h39.18v26.18h133V174.68h27.45V120.62h29.06v91a14.94,14.94,0,0,1-14.94,14.94H178.88a16.26,16.26,0,0,1-16.27-16.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,248.32c0,1.54-.35,27.61-.93,71.79v.08H177l-128.38,0h-.1V230.53h.1l71.4,0h.06v.07a14.39,14.39,0,0,0,2.53,6.88,19.77,19.77,0,0,0,4.95,5,28,28,0,0,0,12,4.42,89.62,89.62,0,0,0,11.24.77l9.49.23,17.67.44L160.3,248l-9.47-.21a89.68,89.68,0,0,1-11.25-.75,28,28,0,0,1-12.08-4.43,19.76,19.76,0,0,1-5-5,14.6,14.6,0,0,1-2.56-7l.08.07-71.4,0,.1-.1v89.49l-.1-.11L177,320l-.08.08C177.59,275.93,178,249.86,178,248.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.31,438.39s0-.48,0-1.39,0-2.26,0-4c0-3.53,0-8.71,0-15.36,0-13.28-.06-32.43-.11-55.93l.2.2-130.9.06h0l.26-.26c0,27.15,0,53.09,0,76.7l-.24-.24,94.17.11,27,.07,7.21,0h1.86l.64,0h-.61l-1.83,0-7.16,0-27,.06-94.33.12h-.25v-.24c0-23.61,0-49.55,0-76.7v-.26h.27l130.9.06h.21v.2c0,23.55-.09,42.74-.11,56.06,0,6.63,0,11.79-.05,15.31,0,1.74,0,3.07,0,4S259.31,438.39,259.31,438.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.49,366.33c0,.08-.61.1-1,.83a1.54,1.54,0,0,0-.14,1.32,1.43,1.43,0,0,0,2.56-.12,1.57,1.57,0,0,0-.27-1.3,2.19,2.19,0,0,0-1.11-.73s.14-.09.41-.06a1.64,1.64,0,0,1,1,.56,1.87,1.87,0,0,1,.44,1.66,1.87,1.87,0,0,1-3.47.16,1.87,1.87,0,0,1,.28-1.69,1.64,1.64,0,0,1,.93-.65C253.34,366.25,253.49,366.3,253.49,366.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,366.33c0,.08-.61.1-1,.83a1.54,1.54,0,0,0-.14,1.32,1.3,1.3,0,0,0,1.32.74,1.28,1.28,0,0,0,1.24-.86,1.53,1.53,0,0,0-.27-1.3,2.15,2.15,0,0,0-1.11-.73s.14-.09.41-.06a1.64,1.64,0,0,1,1,.56,1.88,1.88,0,0,1,.45,1.66,1.88,1.88,0,0,1-3.48.16,1.87,1.87,0,0,1,.28-1.69,1.63,1.63,0,0,1,.94-.65C133.85,366.25,134,366.3,134,366.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.64,431.3c0,.09-.61.11-1,.84a1.54,1.54,0,0,0-.14,1.32,1.3,1.3,0,0,0,1.32.74,1.32,1.32,0,0,0,1.24-.86,1.56,1.56,0,0,0-.27-1.3c-.5-.69-1.13-.65-1.11-.74s.14-.09.41-.06a1.69,1.69,0,0,1,1,.57,1.86,1.86,0,0,1,.44,1.65,1.87,1.87,0,0,1-3.47.17,1.87,1.87,0,0,1,.28-1.69,1.68,1.68,0,0,1,.93-.66C253.49,431.23,253.64,431.28,253.64,431.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.91,366.33c0,.08-.61.1-1,.83a1.58,1.58,0,0,0-.15,1.32,1.43,1.43,0,0,0,2.57-.12,1.57,1.57,0,0,0-.27-1.3,2.16,2.16,0,0,0-1.12-.73s.14-.09.42-.06a1.69,1.69,0,0,1,1,.56,1.9,1.9,0,0,1,.44,1.66,1.87,1.87,0,0,1-3.47.16,1.84,1.84,0,0,1,.28-1.69,1.58,1.58,0,0,1,.93-.65C270.77,366.25,270.91,366.3,270.91,366.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.06,431.3c0,.09-.61.11-1,.84a1.62,1.62,0,0,0-.14,1.32,1.3,1.3,0,0,0,1.32.74,1.32,1.32,0,0,0,1.25-.86,1.56,1.56,0,0,0-.27-1.3c-.5-.69-1.13-.65-1.12-.74s.14-.09.41-.06a1.66,1.66,0,0,1,1,.57,1.86,1.86,0,0,1,.45,1.65,1.88,1.88,0,0,1-3.48.17,1.87,1.87,0,0,1,.29-1.69,1.65,1.65,0,0,1,.93-.66C270.91,431.23,271.06,431.28,271.06,431.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.69,366.33c0,.08-.61.1-1,.83a1.58,1.58,0,0,0-.15,1.32,1.43,1.43,0,0,0,2.57-.12,1.57,1.57,0,0,0-.27-1.3,2.16,2.16,0,0,0-1.12-.73s.14-.09.42-.06a1.66,1.66,0,0,1,1,.56,1.9,1.9,0,0,1,.44,1.66,1.87,1.87,0,0,1-3.47.16,1.87,1.87,0,0,1,.28-1.69,1.58,1.58,0,0,1,.93-.65C314.55,366.25,314.7,366.3,314.69,366.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.84,431.3c0,.09-.61.11-1,.84a1.58,1.58,0,0,0-.15,1.32,1.43,1.43,0,0,0,2.57-.12A1.56,1.56,0,0,0,316,432c-.5-.69-1.13-.65-1.12-.74s.14-.09.42-.06a1.72,1.72,0,0,1,1,.57,1.89,1.89,0,0,1,.44,1.65,1.87,1.87,0,0,1-3.47.17,1.84,1.84,0,0,1,.28-1.69,1.65,1.65,0,0,1,.93-.66C314.7,431.23,314.84,431.28,314.84,431.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.85,431.3c0,.09-.61.11-1,.84a1.54,1.54,0,0,0-.14,1.32,1.43,1.43,0,0,0,2.56-.12A1.52,1.52,0,0,0,135,432c-.5-.69-1.13-.65-1.12-.74s.14-.09.41-.06a1.66,1.66,0,0,1,1,.57,1.86,1.86,0,0,1,.45,1.65,1.88,1.88,0,0,1-3.48.17,1.9,1.9,0,0,1,.28-1.69,1.7,1.7,0,0,1,.94-.66C133.7,431.23,133.85,431.28,133.85,431.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.38,438.39s0-.14,0-.39,0-.63,0-1.1c0-1,0-2.42,0-4.26,0-3.72,0-9.12-.07-15.91,0-13.58-.07-32.72-.11-55l.24.24-37.13,0h0l.26-.26c0,29.66-.05,56.67-.07,76.7l-.19-.19,27.1.1,7.42.05,1.94,0,.67,0-.63,0-1.91,0-7.37.05-27.22.1h-.19v-.19c0-20-.05-47-.07-76.7v-.26h37.64v.25c-.05,22.39-.09,41.58-.12,55.21,0,6.76-.05,12.14-.07,15.85,0,1.82,0,3.23,0,4.21,0,.46,0,.81,0,1.07A2.45,2.45,0,0,1,301.38,438.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.53,398.72c0,.15-7.89.26-17.6.26s-17.61-.11-17.61-.26,7.88-.26,17.61-.26S300.53,398.58,300.53,398.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.25,438.39s0-.49,0-1.41,0-2.29,0-4.07c0-3.57,0-8.79-.05-15.47,0-13.34-.07-32.49-.11-55.75l.21.21-107.8.05h0l.26-.26c0,27.46,0,53.52,0,76.7l-.24-.24,77.72.12,22.15.06,5.89,0h1.52l.53,0h-.5l-1.49,0-5.85,0-22.09.07-77.88.12h-.24v-.24c0-23.18,0-49.24,0-76.7v-.26h.27l107.8.05h.21v.21c0,23.31-.09,42.51-.11,55.89,0,6.65,0,11.86-.06,15.42,0,1.76,0,3.1,0,4S415.25,438.39,415.25,438.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.56,92.63V210.44h87.67V92.61S51.56,93.58,51.56,92.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.56 92.88 51.56 111.2 139.26 111.74 139.26 92.63 51.56 92.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.28,101.06v3.59h28.08v-3.11S84,101.06,83.28,101.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.45,
    y: 119.64,
    width: 27.45,
    height: 29.44,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.07,179.91l1.21,0,3.48,0,12.76,0-.08.08c0-8.76,0-20.34,0-33v-7.48h.1l25.24,0-.08.08c.09-5.46.16-9.91.21-13,0-1.51,0-2.7.07-3.56s0-1.25,0-1.25,0,.43,0,1.25,0,2,0,3.56c0,3.13-.08,7.58-.14,13v.08h-.08l-25.24,0,.11-.11v7.38c0,12.68,0,24.26,0,33V180h-.08l-12.76,0-3.48,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.75,188.63l-2.08,0-5.88,0-21,0h-.09v-.09c0-8.46,0-18.44,0-29.09V145.86h17.41l-.08.09c0-8.14,0-14.91,0-19.68,0-2.34,0-4.19,0-5.5s0-1.94,0-1.94,0,.68,0,1.94,0,3.16,0,5.5c0,4.77,0,11.54,0,19.68v.09h-17.4l.1-.1c0,4.34,0,8.9,0,13.58,0,10.65,0,20.63,0,29.09l-.09-.09,21,0,5.88,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.63 155.51 56.63 158.27 78.84 158.27 78.84 154.96 56.63 155.51",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.45 160.32 56.45 163.09 78.66 163.09 78.66 159.77 56.45 160.32",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,320.11c0-1.49,0-27-.08-70.37l.08.08-153.19,0h0l.11-.1c0,24.74,0,48.55,0,70.37l-.1-.1,153.2.1-153.2.1h-.1V249.64h.11l153.19,0h.07v.08C449.06,293.07,449,318.62,449,320.11Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.88,447.1c0,.14-89.5.26-199.87.26s-199.89-.12-199.89-.26,89.48-.26,199.89-.26S449.88,447,449.88,447.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bench--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.77,
    y: 340.35,
    width: 8.53,
    height: 106.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.84,
    y: 340.35,
    width: 8.53,
    height: 106.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.71,
    y: 327.93,
    width: 297.94,
    height: 13.51,
    rx: 5.94,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.65,101.5,282.8,89.35l-33.51,12c-4.28,2-8,3.23-8,7.21V128.4a75,75,0,0,0,11,39.5,68.78,68.78,0,0,0,30.84,27.24c13.7-4.45,23.93-16.32,30.18-26.46a75,75,0,0,0,11.05-39.5V111.33C324.36,105.64,321.34,102.87,316.65,101.5Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M283.13,183.62a54.71,54.71,0,0,1-24.4-21.72A59.43,59.43,0,0,1,250,130.64V116.72c0-3.15,1.9-6.11,5.68-7.87l27.13-10.14V89.35l-33.51,12c-3.52,1.53-8,3.23-8,7.21V128.4a75,75,0,0,0,11,39.5,68.78,68.78,0,0,0,30.84,27.24Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M283.13,195.14a41,41,0,0,0,6.65-2.85,59.58,59.58,0,0,0,14.07-11.07,75.46,75.46,0,0,0,9.79-13.15,72.22,72.22,0,0,0,10.72-39.88l0-16.39c0-8.16-4.21-8.76-7.73-10.3L282.8,89.35v9.36L310.26,109c3.78,1.77,5.68,4.72,5.68,7.88v13.92a59.34,59.34,0,0,1-8.74,31.25,53.32,53.32,0,0,1-24.07,21.56Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M291.78,129.75l0-2.68a8.79,8.79,0,0,0-17.57,0l0,2.73a4.92,4.92,0,0,0-4.2,4.86v15.8a4.92,4.92,0,0,0,4.92,4.91h16.4a4.91,4.91,0,0,0,4.92-4.91v-15.8A4.92,4.92,0,0,0,291.78,129.75Zm-6.4,16.76h-4.29l.67-3.09a2.61,2.61,0,1,1,2.83,0Zm4.51-16.78H276.1l0-2.66a6.9,6.9,0,0,1,13.79,0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.48,129.56a10.75,10.75,0,0,1-.5-2.75,45.78,45.78,0,0,1-.28-6.74c0-1.32.13-2.57.25-3.71a7.73,7.73,0,0,1,.75-3,3.43,3.43,0,0,1,1.48-1.49c.46-.22.75-.21.75-.17a3.8,3.8,0,0,0-1.85,1.85,8.05,8.05,0,0,0-.59,2.85c-.09,1.13-.16,2.37-.2,3.68-.07,2.61,0,5,.1,6.68A16.43,16.43,0,0,1,255.48,129.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,138.2c-.16,0-.31-.81-.33-1.82s.1-1.83.26-1.84.31.82.33,1.83S256.14,138.2,256,138.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.14,91.46a17.8,17.8,0,0,1,2.68.87,14.22,14.22,0,0,1,3,1.64A10.28,10.28,0,0,1,337,97.45a12.57,12.57,0,0,1,1.46,5.73c0,2.18,0,4.54,0,7.09,0,5.09.05,10.91,0,17.4a92.35,92.35,0,0,1-2.74,21.15,90.11,90.11,0,0,1-9.31,23,99.28,99.28,0,0,1-17.09,21.89c-7,6.69-15.64,12.61-25.73,15.75l-.09,0-.09,0a105.16,105.16,0,0,1-10.33-5.1,95.53,95.53,0,0,1-9.87-6.57,89.33,89.33,0,0,1-17.2-17.37,90.57,90.57,0,0,1-18.19-48.32c-.32-4.15-.23-8.25-.24-12.28V107.89c0-2,0-3.88,0-5.79a21.65,21.65,0,0,1,.1-2.89,5.63,5.63,0,0,1,1.16-2.67,12.69,12.69,0,0,1,4.57-3.28c1.67-.79,3.35-1.48,5-2.21h0l44.59-15,.05,0,.06,0,33.08,11.31,8.83,3,2.27.79.77.29s-.27-.07-.78-.24l-2.29-.75-8.86-3L283.08,76.34h.11L238.64,91.47h0c-1.64.73-3.33,1.42-5,2.21a12.28,12.28,0,0,0-4.41,3.16,5.13,5.13,0,0,0-1.06,2.46,21.58,21.58,0,0,0-.09,2.81v5.79c0,3.89,0,7.86,0,11.88s-.07,8.12.25,12.24a90.1,90.1,0,0,0,18.1,48.05,88.91,88.91,0,0,0,17.11,17.27,93.85,93.85,0,0,0,9.81,6.53A104.14,104.14,0,0,0,283.67,209h-.17c10-3.1,18.55-9,25.55-15.62a99.1,99.1,0,0,0,17.05-21.76,90.64,90.64,0,0,0,9.31-22.83,92.24,92.24,0,0,0,2.79-21.06c0-6.48,0-12.31.06-17.4,0-2.55,0-4.92,0-7.08a12.29,12.29,0,0,0-1.39-5.66,10.34,10.34,0,0,0-3.09-3.46,15.18,15.18,0,0,0-3-1.66,20.62,20.62,0,0,0-2-.72Z",
    style: {
      fill: "#B0BEC5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.8,249.41l2.49,47,62.56,1.43-4.63-36.52L288,224c-3.14-17.48-27.65-18.69-27.65-18.69L241.12,205a33.85,33.85,0,0,0-18.93,4.2s-19.52,10.63-19.35,37.64",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.54,204.77a19.83,19.83,0,0,1-1.69,3.8,10.14,10.14,0,0,1-8.43,4.43,10,10,0,0,1-8.46-4.37,10.21,10.21,0,0,1-1.2-2.78,5.41,5.41,0,0,0-.33-1.08,3.52,3.52,0,0,0,.1,1.14,9,9,0,0,0,1.08,2.93,8.94,8.94,0,0,0,3.31,3.27,10.7,10.7,0,0,0,5.5,1.49,10.46,10.46,0,0,0,5.48-1.53,9.75,9.75,0,0,0,3.31-3.27,10.11,10.11,0,0,0,1.17-2.9A3.12,3.12,0,0,0,260.54,204.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.24,220.5a26.62,26.62,0,0,0-10,19.71c-.48,11.94-1.22,28.52-1.66,29.35-1.37,2.56-37.56.38-41.37.11l-4.6-1.42s-8.46-7.32-10-5.12,4.44,3.61,5.6,7.93-10.86.94-11.64.41l-3.1-.88s1.84,5.9,3.41,7.77c5,6,16.49,9,16.49,9s46.87,15.23,65.8,2.66c6.19-4.11,7.24-44.4,4.9-60a12.46,12.46,0,0,0-12.48-10.6Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.71,277.24a22,22,0,0,0-2.85-1.49,23.48,23.48,0,0,0-2.88-1.42,10.35,10.35,0,0,0,2.72,1.74A10.6,10.6,0,0,0,205.71,277.24Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,214.87c5.77,5.52,11.36,16.6,9.29,38.77l-30.75-1.27.79-30.34a10.26,10.26,0,0,1,4-7.83h0A12.84,12.84,0,0,1,283,214.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.72,441l-.82-11.63,21.77-1.69,1.39,17-1.34.19c-6,.8-30.48,3.65-34.59,2.74C203.55,446.6,221.72,441,221.72,441Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.15,445.12a7.6,7.6,0,0,1,2.42-4.86,7.37,7.37,0,0,1,5-2l.48,6.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.87,444.06s-6.34,2.37-5.45,3.38,25.75-.94,36.64-2.76l-.07-.48-29,2.51S214.14,444,212.87,444.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.33,444.16l-.37.07-1.07.15-3.95.48c-3.33.38-7.94.84-13,1.25s-9.74.66-13.09.81l-4,.14-1.08,0a1.38,1.38,0,0,1-.38,0l.38,0,1.08-.07,4-.23c3.35-.19,8-.48,13.08-.89s9.71-.84,13-1.17l4-.4,1.07-.1A1.56,1.56,0,0,1,244.33,444.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,447.05a5.71,5.71,0,0,0-2.35-3.24,2.93,2.93,0,0,1,1.68,1.25A2.9,2.9,0,0,1,215,447.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.21,443.29c-.06,0-.39-.31-.75-.78s-.6-.9-.54-.94.4.3.75.78S221.27,443.24,221.21,443.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.9,442.22c0,.06-.4-.15-.8-.45s-.7-.61-.65-.67.41.15.81.46S223,442.16,222.9,442.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.86,440.08a2.78,2.78,0,0,1-1.13.23,2.57,2.57,0,0,1-1.15,0,2.6,2.6,0,0,1,1.13-.23A2.41,2.41,0,0,1,223.86,440.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.13,438.6a2.28,2.28,0,0,1-1.24.46,2.21,2.21,0,0,1-1.33-.07,7.85,7.85,0,0,1,1.29-.19A7.18,7.18,0,0,1,224.13,438.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.33,441.45a4.28,4.28,0,0,1-1.4.1,7.73,7.73,0,0,1-1.52-.22,3.71,3.71,0,0,1-.88-.28.77.77,0,0,1-.38-.41.55.55,0,0,1,.17-.57,2.57,2.57,0,0,1,3.23.5,2.51,2.51,0,0,1,.53.9,1,1,0,0,1,.07.37,4.08,4.08,0,0,0-.73-1.14,2.52,2.52,0,0,0-1.26-.68,2.15,2.15,0,0,0-1.66.24c-.21.18-.1.44.16.56a4.3,4.3,0,0,0,.81.28,9.55,9.55,0,0,0,1.47.26C219.79,441.44,220.32,441.4,220.33,441.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,441.54a1.37,1.37,0,0,1-.24-1,2.41,2.41,0,0,1,.3-1.06,1.42,1.42,0,0,1,1.11-.8.54.54,0,0,1,.48.61,1.51,1.51,0,0,1-.18.64,4.13,4.13,0,0,1-.6.9c-.4.47-.74.66-.76.63s.26-.27.61-.74a4.86,4.86,0,0,0,.53-.89c.16-.31.25-.85-.1-.89s-.68.37-.88.67a2.34,2.34,0,0,0-.32.94A4.69,4.69,0,0,0,220,441.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.42,438.23s-.63,0-1.6.19a6.83,6.83,0,0,0-5.35,5c-.26,1-.24,1.59-.29,1.59a1.13,1.13,0,0,1,0-.44,5.77,5.77,0,0,1,.15-1.2,6.63,6.63,0,0,1,5.49-5.13,6,6,0,0,1,1.2-.06A1.72,1.72,0,0,1,243.42,438.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.45,429.35a35.09,35.09,0,0,1,.54,4.46,38.19,38.19,0,0,1,.28,4.48,35.09,35.09,0,0,1-.54-4.46A38.19,38.19,0,0,1,240.45,429.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.25,443.21a17.68,17.68,0,0,1-6.36.56c0-.08,1.43-.1,3.18-.26S233.23,443.14,233.25,443.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.51,442.87c.06.05-.09.31-.21.65s-.17.64-.25.64-.14-.34,0-.73S237.46,442.83,237.51,442.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,440.75c.05,0-.07.28-.28.53s-.42.4-.47.36.06-.29.27-.53S238.91,440.7,239,440.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.2,439.65c0,.08-.3.1-.61.24s-.53.32-.59.28.09-.36.48-.53S241.21,439.58,241.2,439.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.8,439.09c0,.07-.08.19-.26.27s-.34.1-.37,0,.08-.19.26-.27S242.77,439,242.8,439.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.8,441.55l.29-11.65,21.84.41-.25,17.05-1.36.07c-6,.22-30.68.69-34.69-.6C136.17,445.38,154.8,441.55,154.8,441.55Z",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.76,447a7.64,7.64,0,0,1,2.88-4.6,7.35,7.35,0,0,1,5.13-1.49l-.11,6.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.69,443.75s-6.54,1.75-5.75,2.84,25.72,1.54,36.74.77l0-.48-29.08-.29S147,443.82,145.69,443.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177,446.87l-.38,0-1.08.05-4,.1c-3.36.06-8,.08-13.11,0s-9.75-.27-13.1-.45l-4-.24-1.07-.08a1.65,1.65,0,0,1-.38,0,2.21,2.21,0,0,1,.38,0l1.08,0,4,.15c3.35.13,8,.28,13.1.37s9.74.1,13.1.09h5.05A1.59,1.59,0,0,1,177,446.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.57,446.93a9,9,0,0,0-.71-1.9,8.57,8.57,0,0,0-1.33-1.55,3.52,3.52,0,0,1,2,3.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.07,443.78c-.06,0-.36-.34-.67-.85s-.51-.95-.45-1,.36.35.67.85S154.13,443.74,154.07,443.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.85,442.88c0,.05-.39-.18-.76-.53s-.63-.67-.58-.72.39.18.76.53S155.9,442.83,155.85,442.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,440.84a2.56,2.56,0,0,1-1.14.12,2.4,2.4,0,0,1-1.14-.14,5.06,5.06,0,0,1,2.28,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.42,439.39a2.19,2.19,0,0,1-1.28.35,2.25,2.25,0,0,1-1.31-.2,7.12,7.12,0,0,1,1.3-.07A8.14,8.14,0,0,1,157.42,439.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.36,441.86a4,4,0,0,1-1.4,0,8,8,0,0,1-1.49-.36,4.06,4.06,0,0,1-.85-.37.78.78,0,0,1-.34-.44.55.55,0,0,1,.23-.55,2.56,2.56,0,0,1,3.17.81,2.65,2.65,0,0,1,.44.94.92.92,0,0,1,0,.38,4.21,4.21,0,0,0-.62-1.21,2.53,2.53,0,0,0-1.19-.8,2.2,2.2,0,0,0-1.67.08c-.23.17-.14.43.1.58a4.54,4.54,0,0,0,.78.35,9.7,9.7,0,0,0,1.44.4C152.83,441.81,153.36,441.82,153.36,441.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,441.93a1.43,1.43,0,0,1-.15-1,2.33,2.33,0,0,1,.41-1,1.39,1.39,0,0,1,1.18-.69.56.56,0,0,1,.42.65,1.63,1.63,0,0,1-.25.63,4.65,4.65,0,0,1-.68.83,2.3,2.3,0,0,1-.81.56s.28-.25.68-.69a5,5,0,0,0,.6-.83c.2-.29.34-.82,0-.89s-.72.3-.94.58a2.39,2.39,0,0,0-.41.9A5.23,5.23,0,0,0,153,441.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.66,440.89c0,.05-.63-.07-1.61,0a6.86,6.86,0,0,0-5.81,4.46c-.35.93-.39,1.56-.44,1.55a1.15,1.15,0,0,1,0-.44,5.64,5.64,0,0,1,.26-1.17,6.62,6.62,0,0,1,6-4.58,5.28,5.28,0,0,1,1.2,0A1,1,0,0,1,176.66,440.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.56,431.76a39.64,39.64,0,0,1,.11,4.49,37.41,37.41,0,0,1-.16,4.48,39.64,39.64,0,0,1-.11-4.49A40.27,40.27,0,0,1,174.56,431.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.06,444.86a18.05,18.05,0,0,1-6.39-.05c0-.08,1.44,0,3.19.05S166.05,444.79,166.06,444.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.34,444.94c0,.05-.13.3-.28.62s-.23.61-.31.61-.11-.35.07-.72S170.29,444.88,170.34,444.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,443c.06.05-.09.28-.32.5s-.46.37-.51.31.1-.27.33-.5S171.93,442.91,172,443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.31,442.08c0,.08-.31.07-.63.18s-.56.27-.61.22.13-.35.53-.48S174.33,442,174.31,442.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,441.68c0,.07-.1.18-.28.25s-.36.06-.38,0,.1-.17.28-.24S175.93,441.61,176,441.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,295.07l74.89-.94-15.65,35.21-47.9.19L180.73,437.4H151.47l2.79-120.32a22.73,22.73,0,0,1,19.75-22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.7,429.09c0-.16-6.79-.29-15.17-.29s-15.16.13-15.16.29,6.79.3,15.16.3S181.7,429.25,181.7,429.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.18,332.21l2.11,103.59-33.85,1.66s-5.39-101.49-2.7-130.29c1.84-19.71,77.06-11.24,77.06-11.24,1.09,39.25-42.62,36.28-42.62,36.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.29,427.63a5.29,5.29,0,0,0-1.3-.05l-3.55.08c-3,.1-7.13.28-11.69.51s-8.7.47-11.69.67l-3.53.28a5.21,5.21,0,0,0-1.3.18,6.22,6.22,0,0,0,1.31.05l3.55-.09c3-.09,7.13-.27,11.69-.5s8.7-.47,11.69-.68l3.53-.27A5.56,5.56,0,0,0,247.29,427.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.61,323.51a22.1,22.1,0,0,0-.58,5,21.61,21.61,0,0,0,0,5,22,22,0,0,0,.58-5A21.64,21.64,0,0,0,245.61,323.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.92,294.33a2.63,2.63,0,0,0-.64,0l-1.83,0c-1.59.05-3.9.13-6.74.29s-6.23.41-10,1a29.38,29.38,0,0,0-11.55,4.15,13.07,13.07,0,0,0-2.47,2.15,8.22,8.22,0,0,0-1.62,2.78,28,28,0,0,0-1.19,5.83,97.49,97.49,0,0,0-.42,10v6.74c0,.74,0,1.34,0,1.83a2.63,2.63,0,0,0,0,.64,2.76,2.76,0,0,0,.09-.64c0-.41.09-1,.13-1.83.09-1.59.14-3.89.19-6.73s.11-6.23.54-9.95a28.53,28.53,0,0,1,1.2-5.71,9.51,9.51,0,0,1,3.88-4.62,29.2,29.2,0,0,1,11.29-4.1c3.7-.58,7.08-.87,9.91-1.09l6.72-.47,1.82-.15A2.76,2.76,0,0,0,246.92,294.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13,213.56h0A10.18,10.18,0,0,1,240,203.27c0-3.53.1-6.59.1-6.59s-8.17-.76-8.77-8.85-.34-26.76-.34-26.76h0a28.19,28.19,0,0,1,28.48,1.81l1.26.85-.39,39.76A10.16,10.16,0,0,1,250.13,213.56Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.86,182.85A5.25,5.25,0,0,1,238,183a1.48,1.48,0,0,1-.5,0,.78.78,0,0,1-.53-.43,1.83,1.83,0,0,1,.09-1.22l.69-2.34c1-3.3,2-5.93,2.14-5.88s-.52,2.77-1.54,6.07c-.26.8-.5,1.56-.74,2.32a1.59,1.59,0,0,0-.16.85c0,.16.27.21.56.22A5.54,5.54,0,0,1,239.86,182.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,196.57a18.88,18.88,0,0,0,10.37-3.65s-2.14,6-10.26,5.74Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.6,172.68c.15-.06,5.12-.71,4.65,5.16S257,181.3,257,181.13,258.6,172.68,258.6,172.68Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,179.21s.09.08.26.17a1,1,0,0,0,.76.08,2.53,2.53,0,0,0,1.35-2.17,3.28,3.28,0,0,0-.17-1.49,1.16,1.16,0,0,0-.7-.85.52.52,0,0,0-.63.23c-.09.16-.06.28-.09.29s-.12-.11-.06-.35a.71.71,0,0,1,.27-.35.78.78,0,0,1,.57-.1,1.46,1.46,0,0,1,1,1,3.52,3.52,0,0,1,.22,1.67,2.64,2.64,0,0,1-1.69,2.41,1.08,1.08,0,0,1-.93-.23C259,179.35,259,179.22,259,179.21Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.58,161.56a4.66,4.66,0,0,1-3.33-4.63,5.71,5.71,0,0,1,3.36-4.81,7.38,7.38,0,0,1,6,.1,6.47,6.47,0,0,1,12.77.35c.2-1.56,2-2.43,3.54-2.53a5.19,5.19,0,0,1,4.27,1.57,3.18,3.18,0,0,1,0,4.26,7.21,7.21,0,0,1,5,1.2,5.31,5.31,0,0,1,2.24,4.55,4.22,4.22,0,0,1-3.17,3.77c-.59.13-.74-.27-1.06.24a5.33,5.33,0,0,0-.23,1.7,22.91,22.91,0,0,1-.33,5.54,2.25,2.25,0,0,0-2.82,1.26,6.58,6.58,0,0,0-.32,3.39,1.49,1.49,0,0,1-2.3-.19,4.33,4.33,0,0,1-.59-2.59l-.12-9.36a3.11,3.11,0,0,1-4.61-2.56,6.18,6.18,0,0,1-9.51-1.16,15.17,15.17,0,0,1-3.07,2,5,5,0,0,1-3.6.31,3,3,0,0,1-2.11-2.75l.41-.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.54 295.55 180.6 295.55 167.42 244.5 234.12 244.5 244.68 292.22 260.54 292.6 260.54 295.55",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.54,173.36c.08.11-.66.69-1.76.71s-1.87-.51-1.79-.62.82.13,1.78.1S236.47,173.23,236.54,173.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.66,173.9a1,1,0,1,0,2.07,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79,173.43c.09.11-.65.69-1.76.71s-1.87-.51-1.79-.62.83.13,1.78.1S247.72,173.3,247.79,173.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.92,174a1,1,0,1,0,2.06,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.52,170.8c-.08.43-1.24.59-2.61.61s-2.54-.12-2.62-.55,1.07-1,2.6-1S248.59,170.38,248.52,170.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.91,171.45c-.07.43-1.23.6-2.6.62s-2.54-.13-2.63-.56,1.08-1,2.61-1S237,171,236.91,171.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.13,175.71a5.51,5.51,0,0,1-5.51,5.51c-3,0-4.1-2.46-4.1-5.51s1.06-5.5,4.1-5.5A5.51,5.51,0,0,1,266.13,175.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.15,171.51s4.26-20.44-9.74-19.64l-.67-1.28s8.48-2,11.58,4.6c2.42,5.14.85,16.1.85,16.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.32,181.22a2.59,2.59,0,0,1-1.84-.67,6.25,6.25,0,0,1-2.38-4.08,7.32,7.32,0,0,1,1-4.63c.71-1.07,1.6-1.21,1.59-1.14a4.08,4.08,0,0,0-1.28,1.33,7.83,7.83,0,0,0-.77,4.37,6.4,6.4,0,0,0,2.09,3.86A8.22,8.22,0,0,0,261.32,181.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.21,185c.08.12-.07.37-.39.46s-.59,0-.57-.19.21-.25.43-.31S240.13,184.84,240.21,185Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.57,
    cy: 186.01,
    r: 2.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.6,185.22a17.56,17.56,0,0,1-3.08-4.57,38.73,38.73,0,0,1-2.42-4.94A23.81,23.81,0,0,1,218,180.4C219.39,183.08,220.71,185.13,220.6,185.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.46,173.1c.13.05-.38,1.28-1.71,2.13a3.32,3.32,0,0,1-2.64.68c0-.15,1.17-.33,2.36-1.11S219.33,173,219.46,173.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.49,175.33c.13,0-.32,1.28-1.67,2a2.8,2.8,0,0,1-2.6.33,14.34,14.34,0,0,0,2.34-.78C219.76,176.25,220.35,175.26,220.49,175.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.28,184.63a1.5,1.5,0,1,1-.27-2.1A1.5,1.5,0,0,1,206.28,184.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.41,184.1a8.61,8.61,0,0,1,.13-3.5,14.9,14.9,0,0,1,.79-3.4,10.22,10.22,0,0,1-.27,3.48A20.31,20.31,0,0,1,206.41,184.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.88,178.91a4.13,4.13,0,0,1-4.28-.88c-.34-.37-.4-.71-.34-.73s.23.21.59.46a4.81,4.81,0,0,0,1.54.73C210.71,178.86,211.86,178.75,211.88,178.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.83,186.35a1.5,1.5,0,1,1-.28-2.11A1.5,1.5,0,0,1,210.83,186.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,185.82a8.41,8.41,0,0,1,.13-3.5,14.47,14.47,0,0,1,.79-3.41,10.14,10.14,0,0,1-.28,3.49A19.76,19.76,0,0,1,211,185.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.75,179.93a3,3,0,0,1-2.45.22c-1.39-.33-2.2-1.21-2.1-1.3s1,.5,2.22.79S211.72,179.78,211.75,179.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.25,253.64a3.14,3.14,0,0,1-.54,0l-1.53,0-5.65-.21c-4.77-.2-11.35-.51-18.62-.89l-3.73-.19-.25,0v-.24c0-6.36.06-12,.08-16.12,0-2,.06-3.59.08-4.78,0-.52,0-.94,0-1.29a2.39,2.39,0,0,1,.05-.45,1.27,1.27,0,0,1,.05.45c0,.35,0,.77.05,1.29,0,1.19,0,2.8.07,4.78,0,4.13.06,9.76.09,16.12l-.24-.26,3.72.19c7.27.38,13.86.75,18.62,1l5.64.38,1.53.13A1.74,1.74,0,0,1,292.25,253.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,210a19.28,19.28,0,0,0-3.59-.11,12.71,12.71,0,0,0-7.6,3.64,15.13,15.13,0,0,0-3.91,7.56c-.44,2.18-.35,3.59-.45,3.58a3.38,3.38,0,0,1-.11-1,15,15,0,0,1,4.1-10.53,12.46,12.46,0,0,1,7.94-3.65,10.1,10.1,0,0,1,2.68.18A2.9,2.9,0,0,1,278,210Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.78,225.52a15.73,15.73,0,0,1,.18,2.91c0,1.8.06,4.33,0,7.1-.06,2.62-.11,5-.16,6.94,0,1.11,0,1.91,0,2.7,0-.9,0-1.8,0-3.06,0-2-.1-4.32-.15-7s0-5,0-6.79A15.35,15.35,0,0,1,222.78,225.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.37,270a4.53,4.53,0,1,1-4.53-4.52A4.53,4.53,0,0,1,207.37,270Z",
    style: {
      fill: "#f5f5f5"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.8b86d0a91166e6d7fbe082e45fee16b5.svg";
export { ForwardRef as ReactComponent };